/**
 * Selo do cabeçalho do regulamento a partir do título do ciclo: `2S2026` → `#JOGAJUNTOBB 2026.2`.
 * Título fora do formato `<semestre>S<ano>` não gera selo.
 */
export function cycleBadge(cycleTitle?: string) {
  const match = cycleTitle?.match(/^([12])S(\d{4})$/);

  return match ? `#JOGAJUNTOBB ${match[2]}.${match[1]}` : undefined;
}
